import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, Subject, throwError } from "rxjs";
import { map, retry, catchError } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ReexamapiService {

    //  public SERVER_EXAM_BASEURL = "http://localhost:5001/";
    public SERVER_EXAM_BASEURL:any = "http://examnode.nimiquestionbank.in/";



    constructor(private http: HttpClient) { }
  
  
  enterState(args: any) {
    return this.http.post(this.SERVER_EXAM_BASEURL + 'enterState/', args).pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }
  
  enterIticode(args: any) {
    return this.http.post(this.SERVER_EXAM_BASEURL + 'enterIticode/', args).pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }
  
  liststate() {
    return this.http.get(this.SERVER_EXAM_BASEURL + "liststate/").pipe(
      map((data) => {
        //alert(data);
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }
  
  ccrefStatus(args: any) {
    return this.http.post(this.SERVER_EXAM_BASEURL + "ccrefStatus/" , args).pipe(
      map((data) => {
        //alert(data);
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }
  
  checkccrefStatus(args: any) {
    return this.http.post(this.SERVER_EXAM_BASEURL + "checkccrefStatus/" , args).pipe(
      map((data) => {
        //alert(data);
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }
  
  insertbdnuForm(args: any) {
  
    return this.http.post(this.SERVER_EXAM_BASEURL + "insertbdnuForm/", args).pipe(
      map((data) => {
  
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }
  
  listJcDescriptionTitle(query: string, page: number, offset: number) {
    return this.http.get(this.SERVER_EXAM_BASEURL + "listJcDescriptionTitle?q=" + query + "&page=" + page + "&offset=" + offset).pipe(
      map((data) => {
  
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }
  
  listJcDescriptionTitleCount(query: string, page: number, offset: number) {
    return this.http.get(this.SERVER_EXAM_BASEURL + "listJcDescriptionTitleCount?q=" + query + "&page=" + page + "&offset=" + offset).pipe(
      map((data) => {
  
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }
  
  
  listJcDescriptionTitlePost(args: any) {
    return this.http.post(this.SERVER_EXAM_BASEURL + 'listJcDescriptionTitlePost/', args).pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }
  
  listJcDescriptionTitlePostCount(args: any) {
    return this.http.post(this.SERVER_EXAM_BASEURL + 'listJcDescriptionTitlePostCount/', args).pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }
  
  
  
  
  
  
  
    handleError(error: any) {
      let errorMessage = "";
      if (error.error instanceof ErrorEvent) {
        errorMessage = `${error.error.message}`;
      } else {
        // server-side error
        //errorMessage = `${error.status} <br /> Message: ${error.message}`;
        errorMessage = `Server Error<br /> Message: ${error.message}`;
      }
  
      return throwError(errorMessage);
    }
  
    public get() {
      return this.http.get<any>(this.SERVER_EXAM_BASEURL);
    }
  
  }
  